export class StepAccessConstants {
  public static readonly ACCESS_KEY = 'access';
  public static readonly PUBLIC_KEY = 'public';
  public static readonly REQUIRES_ADDED_KEY = 'requiresAdded';
  public static readonly REQUIRES_COMPLETED_KEY = 'requiresCompleted';
  public static readonly REQUIRES_IDENTIFIED_KEY = 'requiresIdentified';
  public static readonly REQUIRES_OTP_KEY = 'requiresOtpForm';
  public static readonly SUMMARY_KEY = 'summary';
}